module.exports = {
	"base": {
		"welcome": "Maligayang Pagdating sa Mulligans, %{name}!",
		"user": "Impormasyon ukol sa User",
		"devices": "Mga Devices",
		"refunds": "Mga Refund",
		"resources": "Mga Resources",
		"transactions": "Mga Order at Pagbabalik",
		"email": "Email",
		"password": "Password",
		"save": "I-save",
		"sign-out": "Mag-sign Out",
		"cancel": "Kanselahin",
		"close": "Isara",
		"learn-more": "Alamin pa",
		"required": "Kinakailangan",
		"support": "Suporta",
		"bookshelf": "Bookshelf",
		"launch": "Ilunsad",
		"download": "I-download",
		"details": "Mga Detalye",
		"cannot-be-blank": "Hindi maaaring blangko ang %{field}.",
		"saving": "Sini-save...",
		"done": "Tapos na",
		"failed": "Nabigo",
		"copy": "Kopyahin"
	},
	"signin": {
		"login-failure": "Hindi tama ang email o password",
		"welcome-large": "Maligayang Pagdating sa %{brand} <span class='inner'>Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Mag-sign In",
		"forgot-password": "Nakalimutan ang Password mo",
		"new-to-vst": "Bago sa %{brand}?",
		"create-account": "Gumawa ng account",
		"signing-in": "Nagsa-sign in...",
		"signin-failed": "Nabigo ang pag-sign in"
	},
	"transactions": {
		"price": "Presyo",
		"excluded": "(Walang kasamang buwis)",
		"quantity": "Dami",
		"confirmation#": "Kumpirmasyon #",
		"payment": "Pagbabayad",
		"purchased": "Binili",
		"purchase-details": "Mga Detalye ng Pagbili",
		"subtotal": "Sub Total",
		"total": "Kabuuan",
		"tax": "Buwis",
		"loading": "Uy big spender, nilo-load na namin ang mga transaksyon mo...",
		"no-purchases": "Wala kang mga binili.",
		"seller-vat": "VAT ng Nagbebenta",
		"total-vat": "Kabuuang Binayaran na %{vat}",
		"portion": "%{subTax} Buwis %{rate}%",
		"vat-disclosure": "Kasama sa Presyo ang %{vat}",
		"purchases": "Mga Pagbili",
		"refunded-items": "Mga Ni-refund na Item",
		"book-title": "Pamagat ng Aklat",
		"refund-details": "Mga Detalye ng Refund",
		"print-receipt": "I-print ang Resibo",
		"request-refund": "Humiling ng Refund",
		"expired": "Nag-expired",
		"expires-in": "Mag-i-expire sa %{date}",
		"details-refund": "Mga Detalye at Refund",
		"modal": {
			"cant-refund-title": "Hindi Available ang Refund",
			"cant-refund": "Hindi maaaring i-refund ang iyong libro dahil sa isa o higit pang mga sumusunod na dahilan.",
			"cant-refund-1": "Masyado nang maraming nakita sa iyong libro.",
			"cant-refund-2": "14 na araw na ang nakalilipas mula sa petsa ng pagbili.",
			"cant-refund-3": "Na-reveal ang online resources code mo.",
			"cant-refund-4": "Dati nang na-refund ang libro mo.",
			"cant-refund-5": "Na-redeem na at/o na-refund na ang lahat ng code.",
			"cant-refund-6": "30 araw na ang nakalilipas mula sa petsa ng pagbili.",
			"cant-refund-support": "Kung hindi pa rin malinaw sa iyo ang patakaran sa pagrerefund ng %{brand}, makipag-ugnayan sa <a href='%{support_url}' target='_blank'>support</a>."
		},
		"license": {
			"perpetual": "Walang pagkapaso ang online access",
			"days": "%{days} (na) Araw na Access"
		}
	},
	"devices": {
		"description": "Pinahihintulutan ka ng %{brand} na magkaroon ng mga naka-activate na <span>%{desktop}</span> computer at <span>%{mobile}</span> mobile/tablet device sa anumang binigay na panahon.",
		"loading": "Kamusta, kinukuha na namin ang mga device mo :)",
		"no-active": "Wala kang mga aktibong device.",
		"deactivate": "I-deactivate"
	},
	"user": {
		"personal-information": "Personal na Impormasyon",
		"security-information": "Pangseguridad na Impormasyon",
		"notifications": "Mga Notipikasyon",
		"first-name": "Pangalan",
		"last-name": "Apelyido",
		"change-password-title": "Baguhin ang Password",
		"current-password": "Kasalukuyang Password",
		"new-password": "Bagong Password",
		"security-password": "Password",
		"confirm-new-password": "Kumpirmahin ang Bagong Password",
		"security-question": "Pangseguridad na Tanong",
		"security-info-change": "Baguhin",
		"question": "Tanong",
		"answer": "Sagot",
		"notifications-text": "I-email ako ng paminsan-minsang mga updates tungkol sa aktibidad ng aking account, mga updates sa produkto at mga espesyal na alok.",
		"loading": "Kinukuha na ni Spot ang user information mo, saglit lang 🐶",
		"change-password-text": "Dapat naglalaman ang password ng kahit 8 character man lang, uppercase na titik, maliit na titik at special character.",
		"email-locked": "Naka-lock ang Email",
		"email-locked-description": "Wala kang access para baguhin ang iyong email.",
		"email-locked-more": "Mangyaring makipag-ugnayan sa iyong administrador.",
		"security-question6": "Ano ang paborito mong sport?",
		"security-question7": "Ano ang paborito mong flavor ng ice cream?",
		"security-question8": "Ano ang pangalan ng paborito mong alagang hayop?",
		"security-question9": "Noong bata ka pa, ano ang gusto mong maging paglaki mo?",
		"security-question10": "Ano ang apelyido ng paborito mong guro?",
		"new-password-failure": "Hindi natupad ng password ang mga kinakailangan",
		"confirm-password-failure": "Kailangang tugma ang password",
		"new-password-tooltip": "Dapat naglalaman ng kahit 8 character man lang, isang uppercase na titik, maliit na titik at special character.",
		"enter-valid-email": "Pakipasok ang balidong email.",
		"password-cannot-be-same": "Ang password ay hindi maaaring kapareho ng dating password",
		"incorrect-password": "Maling Password",
		"complete-account": "Mukhang kailangan mong <a href='%{href}'>kumpletuhin ang iyong account</a>.",
		"completing-allows": "Magbibigay-daan sa iyo ang pagkumpleto sa iyong account na makapagbasa ng mga aklat offline sa aming mobile apps at makapagbahagi ng mga tala at highlights sa mga kaibigan.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Mga Ancillaries",
		"access-codes": "Mga Access Code",
		"print-on-demand": "Print on Demand",
		"check-pod": "Tingnan ang mga opsyon ng publisher sa pagpi-print para sa iyong mga aklat.",
		"check-now": "Tingnan ito Ngayon",
		"loading": "Maghintay lang, ina-update namin ang iyong resources!",
		"in": "sa",
		"access-code-intro": "Ang access code ay isang password na ginagamit mo para ma-access ang nilalaman ng course online. Sa sandaling na-reveal mo ang code para sa item na iyon, hindi mo na maaaring ibalik ito. Para sa higit pang mga tagubilin kung paano gamitin ang iyong mga access code, bisitahin ang <a href='%{support_url}' target='_blank'>Support</a>.",
		"expires": "Mapapaso",
		"expiration-message": "Naglalaman ng mga tagubilin para sa paggamit ng iyong access code.",
		"copy-fail": "Hindi makopya. Mangyaring piliin ang code at manu-manong kopyahin ito.",
		"launch-site": "Ilunsad ang Site",
		"launch-book": "Buksan ang Libro",
		"reveal-code": "Ipakita ang Code",
		"no-resources": "Wala kang anumang resources.",
		"no-access-codes": "Wala kang anumang mga access code.",
		"no-ancillaries": "Walang mga ancillary para sa pamagat na ito",
		"name": "Pangalan",
		"type": "Uri",
		"size": "Laki",
		"download-all": "I-download Lahat",
		"back": "Bumalik sa resources"
	},
	"refunds": {
		"states": {
			"refunded": "Ni-refund",
			"unavailable": "Hindi Available ang Refund"
		},
		"reasons": {
			"dropped": "Binitawan ko ang course",
			"wrong": "Maling libro ito para sa aking course",
			"print": "Nagpasya akong bumili ng naka-print na bersyon sa halip",
			"missing": "Hindi naglalaman ang libro ng lahat ng kinakailangan ko para sa aking course (hal., CD, web access, mga video)",
			"other": "Iba pa"
		},
		"bulk": {
			"policy": "Sa pag-click sa button na &quot;Kumpletuhin ang Refund&quot; sa ibaba, sumasang-ayon ako sa patakaran ng %{brand} <a href='%{policy_url}' target='_blank'>sa pag-refund</a>.",
			"complete": "Kumpletuhin ang Refund",
			"view-details": "Tingnan ang mga Detalye ng Refund",
			"success": "Hiniling na ang iyong refund. Mangyaring maghintay ng 48 oras para sa pagproseso.",
			"failure": "Oops - nagkaroon ng problema! Sa kasamaang palad, hindi nagawa ang iyong refund.",
			"retry": "Subukan Ulit",
			"support": "Makipag-ugnayan sa Suporta",
			"available-codes": "Mga Available na Code",
			"codes-selected": "Mga Piniling Code",
			"download": "I-download ang Mga Code",
			"partially-refunded": "Bahagya Lang ang Na-refund",
			"pick-one": "Dapat kang pumili ng kahit isang code man lang para makapag-refund"
		},
		"refund": "I-refund",
		"all": "I-refund Lahat?",
		"missing-reason": "Dapat kang pumili ng dahilan para magpatuloy",
		"missing-elaboration": "Paki detalye pa",
		"policy": "Sa pag-click sa button na \"Kumpletuhin ang Hiling na Pag-refund\" sa ibaba, nauunawaan ko na kapag binili ko ulit ang %{brand} eTextbook na ito, hindi na ako kwalipikadong humiling ng anumang higit pang mga refund para sa parehong eTextbook. Tingnan ang buong patakaran sa pagsasauli.",
		"refunded": "Ni-refund",
		"sorry": "Ikinalulungkot namin na hindi ka nasiyahan sa iyong binili.",
		"error": "May nangyaring mali.",
		"error-explain": "Hindi namin maproseso ang refund mo. Pakisubukan ulit.",
		"why": "Sabihin sa amin kung bakit?",
		"no-refunds": "Walang kang mga ni-refund na item.",
		"select-codes": "Pumili ng (mga) code na ire-refund:",
		"number": "Ilan?",
		"back": "Bumalik sa refunds"
	},
	"purchases": {
		"back": "Bumalik sa mga pagbili"
	},
	"global-bar": {
		"account": "Mga Settings ng Account"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/fil.json
 ** module id = 1006
 ** module chunks = 0
 **/